import MuiButton from "./button.modifier";
import MuiTooltip from "./tooltip.modifier";

const components = {
  MuiButton,
  MuiTooltip,
};

export default components;
